export default __webpack_public_path__ + "static/media/logoMedium.a71c0abd.svg";